import React, { useState, ReactNode } from 'react';
import styles from './CollapsibleSection.module.scss';
import CustomToolTip from '../../../../../../CommonComponents/CustomToolTip';

interface CollapsibleSectionProps {
  title: React.ReactNode;
  count?: number;
  badge?: string;
  defaultOpen?: boolean;
  onAdd?: () => void;
  children: ReactNode;
}

const CaretIcon = ({ open }: { open: boolean }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    style={{ transform: open ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform 120ms linear' }}
  >
    <path d="M2 3.5l3 3 3-3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlusIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M6 2v8M2 6h8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
  </svg>
);

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title, count, badge, defaultOpen = true, onAdd, children,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={styles.section}>
      <div className={styles.header} onClick={() => setOpen(o => !o)}>
        <CaretIcon open={open} />
        <span className={styles.title}>{title}</span>
        {count !== undefined && <span className={styles.count}>{count}</span>}
        {badge && <span className={styles.badge}>{badge}</span>}
        {onAdd && (
          <CustomToolTip title={typeof title === 'string' ? `Add ${title}` : 'Add'}>
            <button
              className={styles.addBtn}
              type="button"
              onClick={e => { e.stopPropagation(); onAdd(); }}
            >
              <PlusIcon />
            </button>
          </CustomToolTip>
        )}
      </div>
      {open && <div className={styles.body}>{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
